var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93334 0H1.97729C1.71532 0.00117516 1.4644 0.114435 1.27915 0.315112C1.09391 0.51579 0.989366 0.78763 0.988281 1.07143V8.92857C0.989366 9.21237 1.09391 9.48421 1.27915 9.68489C1.4644 9.88557 1.71532 9.99883 1.97729 10H5.93334C6.1953 9.99883 6.44623 9.88557 6.63147 9.68489C6.81671 9.48421 6.92126 9.21237 6.92235 8.92857V1.07143C6.92126 0.78763 6.81671 0.51579 6.63147 0.315112C6.44623 0.114435 6.1953 0.00117516 5.93334 0ZM1.97729 0.714286H5.93334C6.02077 0.714286 6.10462 0.751913 6.16645 0.818891C6.22827 0.885868 6.26301 0.976708 6.26301 1.07143V1.42857H1.64762V1.07143C1.64762 0.976708 1.68235 0.885868 1.74418 0.818891C1.80601 0.751913 1.88986 0.714286 1.97729 0.714286ZM5.93334 9.28571H1.97729C1.88986 9.28571 1.80601 9.24809 1.74418 9.18111C1.68235 9.11413 1.64762 9.02329 1.64762 8.92857V8.57143H6.26301V8.92857C6.26301 9.02329 6.22827 9.11413 6.16645 9.18111C6.10462 9.24809 6.02077 9.28571 5.93334 9.28571Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.d799c95dd8982eeb225008f3dd5c6bd3.svg";
export { ForwardRef as ReactComponent };